import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { appendStringWithValue, FormatISODateTime } from '../../../helpers/formatting'

export default function DiscountForm(props) {
  const { control, responseData } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link to={`user/${responseData?.agent_user_id}`} className="is-link" target="_blank"><b>{responseData?.agent_user_label}</b></Link> requested manager approval to discount customer <Link to={`customer/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.customer_label}</b></Link>&apos;s payment on Loan <Link to={`payment_schedule/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.loan?.label}</b></Link> with <b>{appendStringWithValue('Interest Discount', responseData?.payment?.interest_discount)}{appendStringWithValue('Late Fee Discount', responseData?.payment?.late_fee_discount)}{appendStringWithValue('Loan Fee Discount', responseData?.payment?.loan_fee_discount)}{appendStringWithValue('NSF Fee Discount', responseData?.payment?.nsf_fee_discount)}{appendStringWithValue('Principal Discount', responseData?.payment?.principal_discount)}</b>.
      </h3>
      <h3>{responseData?.description}</h3>

      <div className="divider m-0 my-2"></div>

      <h3>If approving you may modify these values:</h3><br />

      {/* <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Principal Amount:</label>
        <Controller
          name="principal_discount"
          control={control}
          defaultValue={responseData?.payment?.principal_discount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small" disabled={actionDisabled} />
          )}
        />
      </div>

      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Interest Amount:</label>
        <Controller
          name="interest_discount"
          control={control}
          defaultValue={responseData?.payment?.interest_discount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small" disabled={actionDisabled} />
          )}
        />
      </div>
       */}
      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>Late Fee:</label>
        <Controller
          name="late_fee_discount"
          control={control}
          defaultValue={responseData?.payment?.late_fee_discount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>
      <div className="field is-horizontal manager-approval-modal-field">
        <label className={`manager-approval-modal-label`}>NSF Fee:</label>
        <Controller
          name="nsf_fee_discount"
          control={control}
          defaultValue={responseData?.payment?.nsf_fee_discount ?? 0}
          rules={{ required: true }}
          render={({ field }) => (
            <input {...field} type="number" className="input is-small lox-no-border" readOnly />
          )}
        />
      </div>
    </>
  )
}
